export enum ClaimsUrls {
   DETAIL_INFO = '/claim/',
   UPDATE_POLYGON = '/claim/ranch/',
   RESTORE_POLYGON = '/claim/ranch/restore_polygon/',
   RANCH_SPLIT = '/claim/ranch/split/',
   SINISTER_NOTES = '/claim/notes/',
   SATELLITAL_IMAGES = '/claim/satellital/images/',
   SATELLITAL_VALUES = '/claim/satellital/values/',
   STATS_SATELLITAL_VALUES = '/claim/satellital/values/stats/',
   MAP_LAYERS = '/claim/satellital/map_layers/',

   ZONIFICATION = '/claim/satellital/ndvi_zonify/',
   NDVI_DIFF = '/claim/satellital/ndvi_diff/',

   APPRAISERS = '/appraisers/'
}